<h4>View</h4>
<nz-table class="table-dark-zorro" [nzData]="list" [nzShowPagination]="false" nzSize="small">
<thead>
	<tr>
		<th>Id</th>
		<th>Date</th>
		<th>Viewed By</th>
		<th>Record Type</th>
		<th>Record Id</th>
		<th>Record Id Secondary</th>
	</tr>
</thead>
<tbody>
	<tr *ngFor="let data of list">
		<td>{{data.id}}</td>
		<td>{{data.date | date}}</td>
		<td>{{data.viewedBy.username}}</td>
		<td>{{data.recordType}}</td>
		<td>{{data.recordId}}</td>
		<td>{{data.recordIdSecondary}}</td>
	</tr>
</tbody>
</nz-table>
